"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'titles';
exports.FETCH_BRAND = exports.namespace + "/FETCH_BRAND";
exports.FETCH_DEFAULT_EPISODE = exports.namespace + "/FETCH_DEFAULT_EPISODE";
exports.FETCH_SHOW_HIGHLIGHTS = exports.namespace + "/FETCH_SHOW_HIGHLIGHTS";
exports.SAVE_PLAYBACK_POSITION = exports.namespace + "/SAVE_PLAYBACK_POSITION";
exports.SELECT_SEASON = exports.namespace + "/SELECT_SEASON";
exports.MY_LIST = exports.namespace + "/MY_LIST";
exports.SET_BRAND = exports.namespace + "/SET_BRAND";
//# sourceMappingURL=constants.js.map